export enum Category {
    yleinen = 'yleinen',
    naiset = 'naiset',
    vet55 = 'vet55',
    vet65 = 'vet65',
    juniorit = 'juniorit',
    testi = 'testi'
}